const RESTRICTED_OFFERING_VIEWER_ROLES = ['ADMIN', 'INVESTOR_SALES_ADMIN'];

export const canViewRestrictedOffering = (roles?: string[] | null): boolean =>
  Boolean(roles?.some((role) => RESTRICTED_OFFERING_VIEWER_ROLES.includes(role)));
